import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'priceConversion',pure:false })
export class PriceConversionPipe implements PipeTransform {
  constructor(private translateService:TranslateService){

  }
  transform(price, status) {
    let display:string = status=='estimated'?'±':''
    display += price;
    return display;
  }
}